import {
  IMenuBuilderOutput,
  ILeadFoodMenuPayload,
} from "../../../Food/shared/types/foodPayload.types";

export interface ILeadMenuMetadata {
  addedLeadMenuUuid: string | null;
  leadUuid: string | null;
  title: string;
  companyOutletUuid: string | null;
  masterMenuUuid?: string | null;
  masterMenuName?: string | null;
  masterMenuPrice?: string | null;
}

/**
 * Builds the lead food menu save payload from builder output + metadata.
 */
export function buildLeadPayload(
  output: IMenuBuilderOutput,
  metadata: ILeadMenuMetadata
): ILeadFoodMenuPayload {
  return {
    added_lead_menu_uuid: metadata.addedLeadMenuUuid,
    leads_uuid: metadata.leadUuid,
    title: metadata.title,
    description: "",
    menu_json: output.menuJson,
    company_outlet_uuid: metadata.companyOutletUuid,
    status: "ACTIVE",
    is_fixed: output.isFixed ? 1 : 0,
    master_menu_uuid: metadata.masterMenuUuid ?? null,
    master_menu_name: metadata.masterMenuName ?? null,
    master_menu_price: metadata.masterMenuPrice ?? null,
  };
}
